const { userAgent } = window.navigator;
const isAndroid = /android/i.test(userAgent);
const isIOS = /iphone|ipad|itouch|ipod/i.test(userAgent);
const isIpad = /ipad/i.test(userAgent);

const supportWebp = (() => {
  try {
    const ele = document.createElement('object');
    ele.type = 'image/webp';
    ele.innerHTML = '!';
    document.body.appendChild(ele);
    const support = !ele.offsetWidth;
    document.body.removeChild(ele);
    return support;
  } catch (err) {
    return false;
  }
})();

export default {
  isIE: 'ActiveXObject' in window,
  isWeixin: /MicroMessenger/i.test(userAgent) || /weixin/.test(userAgent),
  isMgtvApp: /imgotv/i.test(userAgent),
  isMgECApp: /imgoec/i.test(userAgent),
  isMac: /Macintosh/i.test(userAgent),
  isIOS,
  isIpad,
  isAndroid,
  isWeiBo: /WeiBo/i.test(userAgent),
  isQQ: /QQBrowser/i.test(userAgent),
  isQQApp: /QQ\//i.test(userAgent),
  isMobile: isAndroid || isIOS,
  isPC: !(isAndroid || isIOS),
  supportWebp,
};
